import styled from "styled-components";

/* ── Main Modal ── */

export const ModalTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const ModalTitleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  font-size: 15px;
  box-shadow: 0 2px 6px ${({ theme }) => theme.colors.focusShadow};
`;

export const ModalSearchRow = styled.div`
  margin-bottom: 12px;

  .ant-input-affix-wrapper {
    border-radius: 8px;
    height: 36px;
  }
`;

export const ModalSearchIconBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};

  .anticon {
    font-size: 13px;
    color: inherit;
  }
`;

export const TabLabelWithCount = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const TabCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ theme }) => theme.colors.borderLight || "#f0f0f0"};
  color: ${({ theme }) => theme.colors.gray || "#666"};
`;

export const ManageGroupsTableWrapper = styled.div`
  .ant-table-wrapper .ant-table-tbody > tr > td {
    padding: 12px 16px;
    transition: background 0.2s ease;
  }

  .ant-table-wrapper .ant-table-tbody > tr:hover > td {
    background: ${({ theme }) => theme.colors.tableRowHoverBg} !important;
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors.gray || "#666"};
    background: ${({ theme }) => theme.colors.borderLight || "#fafafa"};
    border-bottom: 2px solid ${({ theme }) => theme.colors.border || "#f0f0f0"};
  }
`;

export const RoleBadge = styled.span`
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  letter-spacing: 0.3px;
  background: ${({ $variant }) => {
    if ($variant === "owner") return "#e6f7f0";
    if ($variant === "shared") return "#f3e8ff";
    if ($variant === "delegated") return "#fff7e6";
    return "#f0f0f0";
  }};
  color: ${({ $variant }) => {
    if ($variant === "owner") return "#0d7e5f";
    if ($variant === "shared") return "#7c3aed";
    if ($variant === "delegated") return "#d97706";
    return "#666";
  }};
`;

export const GroupNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
`;

export const RolesCountLink = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
  cursor: default;
`;

export const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActionMenuButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.colors.border || "#d9d9d9"};
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray || "#666"};
  font-size: 16px;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 2px 6px ${({ theme }) => theme.colors.focusShadow};
  }
`;

export const ModalFooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const FooterSummary = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
`;

/* ── Delete / Archive Modal ── */

export const DeleteModalTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 17px;
  font-weight: 600;
  color: #cf1322;
`;

export const DeleteModalTitleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff1f0;
  color: #cf1322;
  font-size: 15px;
`;

export const DeleteGroupNameBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 20px;
  margin: 16px 0;
  border: 1px solid ${({ theme }) => theme.colors.border || "#d9d9d9"};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.borderLight || "#fafafa"};
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const DeleteWarningBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  margin: 16px 0;
  border-radius: 10px;
  background: #fff2f0;
  border: 1px solid #ffccc7;

  .anticon {
    color: #cf1322;
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
  }
`;

export const DeleteWarningText = styled.span`
  font-size: 13px;
  color: #434343;
  line-height: 1.6;
`;

export const ConfirmLabel = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.dark};
  margin-bottom: 8px;
`;

export const ConfirmInputWrapper = styled.div`
  .ant-input {
    border-radius: 8px;
    height: 40px;
  }
`;

export const ModalActionFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
`;

/* ── Transfer Ownership Modal ── */

export const TransferModalTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const TransferModalTitleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fffbe6;
  color: #d48806;
  font-size: 15px;
`;

export const TransferDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.6;
  margin: 0 0 16px 0;
`;

export const TransferWarningBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  margin: 0 0 16px 0;
  border-radius: 10px;
  background: #fffbe6;
  border: 1px solid #ffe58f;

  .anticon {
    color: #d48806;
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
  }
`;

export const TransferWarningText = styled.span`
  font-size: 13px;
  color: #434343;
  line-height: 1.6;
`;

export const TransferFieldLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
  margin-bottom: 8px;
`;

export const TransferHelperText = styled.p`
  margin: 6px 0 0 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray || "#999"};
`;

/* ── Delegate Access Modal ── */

export const DelegateModalTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const DelegateModalTitleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary}15;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 15px;
`;

export const DelegateDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.6;
  margin: 0 0 16px 0;
`;

export const DelegateInfoBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  margin: 0 0 16px 0;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.primary}08;
  border: 1px solid ${({ theme }) => theme.colors.primary}30;

  .anticon {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
  }
`;

export const DelegateInfoText = styled.span`
  font-size: 13px;
  color: #434343;
  line-height: 1.6;
`;

export const DelegateFieldLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
  margin-bottom: 8px;

  span {
    font-weight: 400;
    color: ${({ theme }) => theme.colors.gray || "#999"};
    font-size: 12px;
    margin-left: 4px;
  }
`;

export const DelegateInputWrapper = styled.div`
  .ant-select {
    width: 100%;
  }

  .ant-select-selector {
    min-height: 40px;
    border-radius: 8px !important;
  }

  .ant-select-selection-item {
    border-radius: 6px;
    background: ${({ theme }) => theme.colors.primary}10;
    border-color: ${({ theme }) => theme.colors.primary}30;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const DelegateHelperText = styled.p`
  margin: 6px 0 0 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray || "#999"};
`;

export const ShareFieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const ShareSectionDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.borderLight || "#f0f0f0"};
`;

export const SharedUsersPanel = styled.div`
  padding: 12px 14px;
  border: 1px solid ${({ theme }) => theme.colors.primary}25;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.primary}06;
`;

export const SharedUsersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const SharedUsersHeaderContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  .anticon {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const SharedUsersCount = styled.span`
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ theme }) => theme.colors.primary}12;
  color: ${({ theme }) => theme.colors.primary};
`;

export const SharedUsersSearchWrapper = styled.div`
  margin-bottom: 8px;

  .ant-input-affix-wrapper {
    height: 34px;
    border-radius: 8px;
  }

  .anticon {
    color: ${({ theme }) => theme.colors.gray || "#999"};
  }
`;

export const SharedUsersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 190px;
  overflow-y: auto;
  padding-right: 4px;
`;

export const SharedUsersResultMeta = styled.div`
  margin: -2px 0 8px 2px;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.gray || "#777"};
`;

export const SharedUserItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white || "#fff"};
  border: 1px solid ${({ theme }) => theme.colors.borderLight || "#f0f0f0"};
  min-width: 0;
`;

export const SharedUserName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SharedUserEmail = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray || "#666"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SharedUsersEmptyText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray || "#999"};
`;

export const SharedUsersNoResultsText = styled.div`
  padding: 10px 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white || "#fff"};
  border: 1px dashed ${({ theme }) => theme.colors.border || "#d9d9d9"};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray || "#999"};
`;

export const DelegateResultsList = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DelegateResultItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${({ $failed, theme }) =>
    $failed ? theme.colors.statusFailed || "#ff4d4f" : theme.colors.dark};
`;
